module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.5625 0.875C3.18008 0.875 0.4375 3.61758 0.4375 7C0.4375 10.3824 3.18008 13.125 6.5625 13.125C9.94492 13.125 12.6875 10.3824 12.6875 7C12.6875 3.61758 9.94492 0.875 6.5625 0.875ZM7 9.95312C7 10.0133 6.95078 10.0625 6.89062 10.0625H6.23438C6.17422 10.0625 6.125 10.0133 6.125 9.95312V6.23438C6.125 6.17422 6.17422 6.125 6.23438 6.125H6.89062C6.95078 6.125 7 6.17422 7 6.23438V9.95312ZM6.5625 5.25C6.39077 5.24649 6.22726 5.17581 6.10705 5.05312C5.98684 4.93044 5.91951 4.76551 5.91951 4.59375C5.91951 4.42199 5.98684 4.25706 6.10705 4.13438C6.22726 4.01169 6.39077 3.94101 6.5625 3.9375C6.73423 3.94101 6.89774 4.01169 7.01795 4.13438C7.13816 4.25706 7.20549 4.42199 7.20549 4.59375C7.20549 4.76551 7.13816 4.93044 7.01795 5.05312C6.89774 5.17581 6.73423 5.24649 6.5625 5.25Z",
      "fill": "#004A98"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2050a9f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Information.vue
// module id = 1478
// module chunks = 159